// extracted by mini-css-extract-plugin
export default {"flag":"Flag_flag--Cls","placeholder":"Flag_placeholder--Zpi","s":"Flag_s--oIY","sm":"Flag_sm--mPX","m":"Flag_m--pMV","l":"Flag_l--lit"};